import clsx from 'clsx'
import { merge } from 'lodash-es'
import { type HTMLMotionProps, motion } from 'motion/react'
import { cloneElement, HTMLAttributes, type MouseEvent, type Ref } from 'react'
import styles from './Item.module.css'
import type { MenuItemData } from './types'

export interface MenuItemProps extends Omit<HTMLMotionProps<'button'>, 'onClick'> {
	data: MenuItemData
	onClick?: (
		id: string,
		data: MenuItemData,
		e: MouseEvent<HTMLElement, globalThis.MouseEvent>
	) => void
	isActive?: boolean
	ref?: Ref<HTMLButtonElement>
}

export default function MenuItem({
	data,
	onClick,
	isActive,
	ref,
	className,
	...props
}: MenuItemProps) {
	const renderIcon = () => {
		if (data.icon) {
			return cloneElement(
				data.icon,
				merge(
					{ width: '16px', height: '16px' } as HTMLAttributes<HTMLImageElement>,
					data.icon.props
				)
			)
		}
		if (data.iconURL)
			return <img width={16} height={16} src={data.iconURL} className={styles.icon} alt="" />
		return null
	}

	return (
		<motion.button
			ref={ref}
			type="button"
			role="menuitem"
			tabIndex={isActive ? 0 : -1}
			aria-selected={isActive}
			onClick={(e) => {
				onClick?.(data.id, data, e)
			}}
			{...props}
			className={clsx(styles.item, isActive && styles.itemActive, className)}
		>
			{renderIcon()}
			{data.title}
		</motion.button>
	)
}
